import * as React from "react"
import { Box } from "@mui/material"

export default function DefaultLayout({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          isolation: "isolate",
          position: "absolute",
          inset: 0,
          zIndex: -2,
          opacity: 0.35,
        }}
      >
        <svg id="texture" height="100%" width="100%">
          <filter id="noise">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.9"
              numOctaves="4"
              stitchTiles="stitch"
            />
            <feColorMatrix type="saturate" values="0" />
          </filter>
          <rect width="100%" height="100%" filter="url(#noise)" />
        </svg>
      </Box>
      <Box
        sx={{
          isolation: "isolate",
          overflow: "hidden",
          position: "absolute",
          right: { xs: -800, sm: -500 },
          // bottom: -1 * (750 / 1.5),
          bottom: 0,
          top: 0,
          zIndex: 0,
          bgcolor: "primary.400",
          // height: 750,
          height: "100vh",
          width: 750,
          borderRadius: 999,
          opacity: 0.5,
          filter: "blur(300px)",
          transform: "translate3d(0, 0, 0)",
        }}
      ></Box>
      {children}
    </Box>
  )
}
